import { useCallback, useEffect, useState } from "react"
import useApi from "./useApi.js"

export default function useMetrics() {
  const api = useApi()
  const [state, setState] = useState({ status: "loading", data: null, error: null })

  const refresh = useCallback(async () => {
    try {
      const data = await api.get("/api/v1/shop/metrics")
      setState({ status: "loaded", data, error: null })
    } catch (err) {
      setState({ status: "error", data: null, error: err.message })
    }
  }, [ api ])

  useEffect(() => { refresh() }, [ refresh ])

  return { ...state, refresh }
}
